<template>
<div class="chapter">
<div class="inner_page">
<p class="h2bc"><a id="page_vii"></a>Contents</p>
<p class="toc" id="rchapter01section01"><a href="#/xhtml/Chapter01#chapter01section01">Rampant Machismo</a></p>
<p class="toc" id="rchapter01section02"><a href="#/xhtml/Chapter01#chapter01section02">Come Up and See My Etchings</a></p>
<p class="toc" id="rchapter01section03"><a href="#/xhtml/Chapter01#chapter01section03">Sneakers and Deceivers</a></p>
<p class="toc" id="rchapter01section04"><a href="#/xhtml/Chapter01#chapter01section04">Headless Males Make Great Lovers</a></p>
<p class="toc" id="rchapter01section05"><a href="#/xhtml/Chapter01#chapter01section05">Trading Food for Sex</a></p>
<p class="toc" id="rchapter01section06"><a href="#/xhtml/Chapter01#chapter01section06">Any Partner Will Do</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?933b2d74